import { useEffect, useRef, useState } from "react";
import { toast } from "sonner";

// Shared divert-alert logic for the MD (MIEMSS) and PA (PA MEDIC) hospital boards.
// Fires a tone + toast and returns the set of hospital keys that should flash.
const MUTE_KEY = "hosp_alert_mute";
export const tone = (freq, dur = 0.35) => {
  try {
    const AC = window.AudioContext || window.webkitAudioContext;
    const ctx = new AC();
    const o = ctx.createOscillator(); const g = ctx.createGain();
    o.type = "square"; o.frequency.value = freq; o.connect(g); g.connect(ctx.destination);
    g.gain.setValueAtTime(0.0001, ctx.currentTime);
    g.gain.exponentialRampToValueAtTime(0.1, ctx.currentTime + 0.02);
    g.gain.exponentialRampToValueAtTime(0.0001, ctx.currentTime + dur);
    o.start(); o.stop(ctx.currentTime + dur + 0.05);
  } catch { /* no audio */ }
};
export const divertTone = () => { tone(880); setTimeout(() => tone(660), 250); setTimeout(() => tone(880), 500); };

export function useHospitalAlerts(storageKey) {
  const prev = useRef(null);
  const [flash, setFlash] = useState({});
  const [muted, setMuted] = useState(() => localStorage.getItem(MUTE_KEY) === "1");
  const toggleMute = () => setMuted((m) => { localStorage.setItem(MUTE_KEY, m ? "0" : "1"); return !m; });

  // items: [{key, name, critical:boolean, reason}] — compares against last poll
  const check = (items) => {
    const now = Object.fromEntries(items.map((i) => [i.key, i]));
    if (prev.current) {
      const flipped = items.filter((i) => i.critical && !(prev.current[i.key]?.critical));
      if (flipped.length) {
        if (!muted) divertTone();
        flipped.forEach((f) => toast.error(`🏥 ${f.name} → ${f.reason}`, { duration: 20000, id: `${storageKey}-${f.key}` }));
        setFlash((o) => ({ ...o, ...Object.fromEntries(flipped.map((f) => [f.key, Date.now()])) }));
        setTimeout(() => setFlash((o) => { const n = { ...o }; flipped.forEach((f) => delete n[f.key]); return n; }), 120000);
      }
    }
    prev.current = now;
  };
  useEffect(() => () => { prev.current = null; }, []);
  return { check, flash, muted, toggleMute };
}
